import {Tooltip} from 'antd';
import {ReactElement} from 'react';

import {Locale} from '../../../../../provider/locale/localization';
import {getPresenceBlockedTooltipLocaleKey} from '../../../../../service/reviews/review-realtime-presence/review-realtime-presence-helper';
import {ReviewPresenceBlockedActionEnum} from '../../../../../service/reviews/review-realtime-presence/review-realtime-presence-type';

import * as styles from './review-presence-blocked-menu-label.scss';

type PropsType = {
    blockedAction: ReviewPresenceBlockedActionEnum;
    children: ReactElement | string;
    isBlocked: boolean;
};

export function ReviewPresenceBlockedMenuLabel(props: PropsType): ReactElement {
    const {blockedAction, isBlocked, children} = props;

    if (!isBlocked) {
        if (typeof children === 'string') {
            return <span>{children}</span>;
        }

        return children;
    }

    return (
        <Tooltip title={<Locale stringKey={getPresenceBlockedTooltipLocaleKey(blockedAction)} />}>
            <span className={styles.ReviewPresenceBlockedMenuLabel}>{children}</span>
        </Tooltip>
    );
}
